export default __webpack_public_path__ + "static/media/61.42a3cf8e.jpg";